import { render, staticRenderFns } from "./DragContainer.vue?vue&type=template&id=24831d7f&scoped=true&"
import script from "./DragContainer.vue?vue&type=script&lang=ts&"
export * from "./DragContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DragContainer.vue?vue&type=style&index=0&id=24831d7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24831d7f",
  null
  
)

export default component.exports